query GetInvestmentAccountPerformances {
  investmentAccountPerformances {
    id
    fundAccount {
      id
      currency
      sageCode
      fund {
        id
        name
        legalEntity {
          id
          name
        }
      }
    }
    poolPerformance {
      id
      period {
        id
        name
        openingDate
        closingDate
        lockedDate
      }
      pool {
        id
        name
        currency
        legalEntity {
          id
          name
        }
        isActive
      }
      returnForPeriod
      dividendAndInterest
      changeInMarketValue
      fees
      floatDelta
    }
    description
    openingBalance
    openingPrinciple
    openingUnrealisedGainsLossesCumulative
    realisedGainsLosses
    closingPrinciple
    accumulativeReturnsForPeriod
    closingBalance
    totalContributionsForPeriod
    totalWeightedContributionsForPeriod
    totalGrantsForPeriod
    totalWeightedGrantsForPeriod
    netReturnsForPeriod
    dividendAndInterest
    changeInMarketValue
    fees
    caseStatus
    salesforceCaseId
  }
}
